/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const komboIntegrationDataIntegrationTypeSchema = z.enum(['ATS', 'HRIS'])

export type KomboIntegrationDataIntegrationTypeSchema = z.infer<typeof komboIntegrationDataIntegrationTypeSchema>
